/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InviteCommand
 */
export interface InviteCommand {
    /**
     * 
     * @type {string}
     * @memberof InviteCommand
     */
    employeeId: string;
    /**
     * 
     * @type {string}
     * @memberof InviteCommand
     */
    roleId: string;
}

/**
 * Check if a given object implements the InviteCommand interface.
 */
export function instanceOfInviteCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "employeeId" in value;
    isInstance = isInstance && "roleId" in value;

    return isInstance;
}

export function InviteCommandFromJSON(json: any): InviteCommand {
    return InviteCommandFromJSONTyped(json, false);
}

export function InviteCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): InviteCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'employeeId': json['employeeId'],
        'roleId': json['roleId'],
    };
}

export function InviteCommandToJSON(value?: InviteCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'employeeId': value.employeeId,
        'roleId': value.roleId,
    };
}

